import { createContext } from "react";

import type useInstitutionIdentityById from "src/hooks/data/load/useInstitutionIdentityById";

/**
 * Describes the institution identity loader state and its refresh/cache actions.
 */
export interface IInstitutionIdentityContext extends ReturnType<
    typeof useInstitutionIdentityById
> {}

/**
 * Shares institution identity state with descendants.
 *
 * Postconditions: Without a provider, data and error are undefined and both activity flags are
 * false. Default mutate and refresh calls fulfill with undefined without loading or updating data.
 * Assumptions: Consumers need a matching provider to observe live request state.
 */
export const InstitutionIdentityContext = createContext<IInstitutionIdentityContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined
});

export default InstitutionIdentityContext;
